import { render, staticRenderFns } from "./PageWords.vue?vue&type=template&id=14d0e11b&"
import script from "./PageWords.vue?vue&type=script&lang=js&"
export * from "./PageWords.vue?vue&type=script&lang=js&"
import style0 from "./PageWords.vue?vue&type=style&index=0&id=14d0e11b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports